import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  // Common messages
  confirmDowngradeTitle: {
    defaultMessage: 'Are you sure you want to downgrade?',
    description: 'Title for the downgrade confirmation modal',
    id: '+zqcs7',
  },
  userRoleWarning: {
    defaultMessage: 'Downgrading your plan will remove user role controls—any users you keep will automatically receive admin access.',
    description: 'Warning message about user role control changes when downgrading',
    id: 'jLpv9t',
  },
  downgradePrimaryText: {
    defaultMessage: 'By proceeding with this subscription plan downgrade, you will lose access to:',
    description: 'Text explaining what features will be lost',
    id: 'A6iAEr',
  },
  freeDowngradePrimaryText: {
    defaultMessage:
      'By selecting the Free plan, you’ll be limited to one user and won’t have access to any order sources for processing labels.',
    description: 'Primary text for Free plan downgrade',
    id: 'TWurK2',
  },
  downgradeButtonText: {
    defaultMessage: 'Downgrade Plan',
    description: 'Button text to confirm the downgrade',
    id: 'UglSdy',
  },
  cancelButtonText: {
    defaultMessage: 'Cancel',
    description: 'Button text to cancel the downgrade',
    id: 'z4N88X',
  },

  // Feature-specific messages - Premium to Standard downgrade
  dedicatedAccountManager: {
    defaultMessage: 'Dedicated Account Manager',
    description: 'Feature: Dedicated Account Manager',
    id: 's63o3A',
  },
  advancedInventory: {
    defaultMessage: 'Advanced Inventory (POs, Scan to receive, Forecasting)',
    description: 'Feature: Advanced Inventory features',
    id: '0uY6M1',
  },
  warehouse: {
    defaultMessage: 'Warehouse (Pick-to-tote)',
    description: 'Feature: Warehouse management',
    id: '28rXDa',
  },
  customReports: {
    defaultMessage: 'Custom reports',
    description: 'Feature: Custom reports',
    id: 'TPEzCm',
  },
  autoSplit: {
    defaultMessage: 'Auto-split',
    description: 'Feature: Auto-split shipments',
    id: 'BVQ9mT',
  },
  cubiscanIntegration: {
    defaultMessage: 'Cubiscan integration',
    description: 'Feature: Cubiscan Integration',
    id: 'ZZ9rCa',
  },
  odbcIntegration: {
    defaultMessage: 'ODBC database connection',
    description: 'Feature: ODBC Integration',
    id: 'MUnzAr',
  },

  // Feature-specific messages - Standard to Starter downgrade
  userSeats: {
    defaultMessage: '{userCount} additional users',
    description: 'number of additional users',
    id: '2OS1xa',
  },
  bringYourOwnCarrier: {
    defaultMessage: 'Bring your own carrier account',
    description: 'Feature: Bring your own carrier account',
    id: 'g4RuED',
  },
  combineSplitShipments: {
    defaultMessage: 'Combine & split shipments',
    description: 'Feature: Combine and split shipments',
    id: 'X6bjP3',
  },
  unlimitedAutomationRules: {
    defaultMessage: 'Unlimited automation rules',
    description: 'Feature: Unlimited automation rules',
    id: 'bQ/DdW',
  },
  customRateShopper: {
    defaultMessage: 'Custom rate shopper',
    description: 'Feature: Custom rate shopper',
    id: 'i0Yyuo',
  },
  brandedTracker: {
    defaultMessage: 'Branded tracker',
    description: 'Feature: Branded tracker',
    id: 'vm1dHu',
  },
  returnsPortal: {
    defaultMessage: 'Returns portal, refunds, and exchanges',
    description: 'Feature: Returns portal and related features',
    id: 'ooGVlC',
  },
  inventoryWarehouseManagement: {
    defaultMessage: 'Inventory & warehouse management',
    description: 'Feature: Inventory and warehouse management',
    id: 'GCnQZ7',
  },
  advancedAnalytics: {
    defaultMessage: 'Advanced analytics',
    description: 'Feature: Advanced analytics',
    id: '2y9Mc5',
  },
  dataExport: {
    defaultMessage: 'Data export',
    description: 'Feature: Data export',
    id: 'J3EF1E',
  },
  customStore: {
    defaultMessage: 'Custom Store',
    description: 'Feature: Custom Store',
    id: 'xmVpck',
  },
  shippingApi: {
    defaultMessage: 'Shipping API',
    description: 'Feature: Shipping API',
    id: 'Od8+I6',
  },
  phoneSupport: {
    defaultMessage: 'Phone support',
    description: 'Feature: Phone support',
    id: '/LJDGS',
  },
});
